import { Tag } from '@scale/scaleui';
import { PlatinumQualityStatus } from '@scale/shared-types';
import _ from 'lodash';

const QualityDashboard = ({
  qualityStatus,
  compact = false,
}: {
  qualityStatus: PlatinumQualityStatus;
  compact?: boolean;
}) => {
  const isOnTrack = qualityStatus === PlatinumQualityStatus.OnTrack;
  const isPending = qualityStatus === PlatinumQualityStatus.Pending;

  return (
    <div
      className={
        !compact
          ? 'border-solid border-2 border-neutral-200 rounded-lg p-4 flex-1 flex flex-col justify-between'
          : ''
      }
    >
      {!compact && (
        <div className="flex">
          <span className="font-semibold text-base">Overall Quality</span>
          <span className="ml-2">
            <Tag
              className={
                isOnTrack
                  ? 'bg-success-50 text-success-700'
                  : isPending
                  ? 'bg-neutral-100'
                  : 'bg-warning-300'
              }
              variant={isOnTrack ? 'success' : isPending ? 'neutral' : 'warning'}
            >
              {_.startCase(qualityStatus)}
            </Tag>
          </span>
        </div>
      )}
      <div>
        <Tag
          className={isOnTrack ? 'bg-success-50' : isPending ? 'bg-neutral-100' : 'bg-warning-200'}
          variant={isOnTrack ? 'success' : isPending ? 'neutral' : 'warning'}
        >
          <div className="flex items-center">
            <div
              className="w-3 h-3 rounded-full mr-1"
              style={{
                background: isOnTrack ? '#367C4F' : isPending ? '#808080' : '#FF6F00',
              }}
            />
            <div
              style={{
                color: isOnTrack ? '#367C4F' : isPending ? '#000000' : '#FF6F00',
              }}
            >
              {isOnTrack
                ? 'Good Quality'
                : isPending
                ? 'Quality Metrics Pending'
                : 'Quality Needs Improvement'}
            </div>
          </div>
        </Tag>
      </div>
      {!compact && (
        <div>
          {isOnTrack
            ? 'You are on track! Keep up the good work.'
            : isPending
            ? 'Your quality metrics are pending. Please reach out to your team lead for more information.'
            : 'Improve quality in order to remain in the program.'}
        </div>
      )}
    </div>
  );
};

export default QualityDashboard;
